export type ButtonVariant = 'gold' | 'white' | 'navy' | 'outline' | 'whatsapp'
export type ButtonSize = 'sm' | 'md' | 'lg'

const base =
  'inline-flex items-center justify-center gap-2 rounded-md font-semibold tracking-tight transition-colors duration-150 ease-out-expo disabled:opacity-60 disabled:cursor-not-allowed'

const variants: Record<ButtonVariant, string> = {
  gold: 'bg-gold text-navy-deep hover:bg-gold-light shadow-card',
  white: 'bg-white text-navy hover:bg-navy-100',
  navy: 'bg-navy text-white hover:bg-navy-700',
  outline: 'border border-navy/25 text-navy hover:bg-navy-100',
  whatsapp: 'bg-[#25D366] text-[#0B3B22] hover:bg-[#1FBB59]',
}

const sizes: Record<ButtonSize, string> = {
  sm: 'px-3.5 py-2 text-sm',
  md: 'px-5 py-3 text-[0.95rem]',
  lg: 'px-6 py-4 text-base',
}

export function buttonClass(
  variant: ButtonVariant = 'gold',
  size: ButtonSize = 'md',
  extra = '',
): string {
  return [base, variants[variant], sizes[size], extra].filter(Boolean).join(' ')
}
